import { AnalyticIdentifier } from '@common/neo.tax';

import { useAnalyticId } from '@neo.tax/shared';

type PayrollQreLayoutAnalyticIds = {
  bulkEditInExcelBtnId: string;
  connectProviderBtnId: string;
  setRdPercentageBtnId: string;
};

export const usePayrollQreLayoutAnalyticIds = (): PayrollQreLayoutAnalyticIds => ({
  bulkEditInExcelBtnId: useAnalyticId(AnalyticIdentifier.QRE_LAYOUT_BULK_EDIT_IN_EXCEL_BTN),
  connectProviderBtnId: useAnalyticId(AnalyticIdentifier.QRE_LAYOUT_CONNECT_PROVIDER_BTN),
  setRdPercentageBtnId: useAnalyticId(AnalyticIdentifier.QRE_LAYOUT_SET_RD_PERCENTAGE_BTN),
});
